
<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col
        class="pa-1"
        cols="8">
        <v-text-field
          v-model="searchMessage"
          label="Search Message"
          append-icon="search"
          clearable
          outlined
          color="teal"
          dense
        />
      </v-col>

      <v-col
        class="pa-1"
        cols="4">
        <v-select
          v-model="orderModel"
          :items="orderByArray"
          label="Order by"
          @change="orderMessages"
          item-text="title"
          item-value="value"
          color="teal"
          outlined
          dense
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        v-for="message in resultQuery"
        :key="message.id"
      >
        <message-card :notice-obj="message" />
      </v-col>

      <v-col v-if="isEmpty">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition"
        >
          There are no messages at the moment.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MessageCard from '../components/MessageCard'

export default {
  components: {
    MessageCard
  },

  data: () => ({
    messages: [],
    searchMessage: '',
    isEmpty: false,
    orderByArray: [
      { title: 'Latest', value: 'desc' },
      { title: 'Oldest', value: 'asc' }
    ],
    orderModel: 'desc'
  }),

  computed: {
    filteredMessages () {
      return this.messages.filter(message => typeof message.id !== 'undefined')
    },

    resultQuery () {
      let results = this.filteredMessages

      if (this.searchMessage) {
        const searchTerms = this.searchMessage.toLowerCase().split(' ')
        results = results.filter(item =>
          searchTerms.every(term => item.contents.toLowerCase().includes(term))
        )
      }

      return results.slice().sort((a, b) => {
        return this.orderModel === 'desc'
          ? new Date(b.sortDate) - new Date(a.sortDate)
          : new Date(a.sortDate) - new Date(b.sortDate)
      })
    }
  },

  async created () {
    await this.loadMessages()
  },

  async mounted () {
    this.$store.dispatch('logReadItems')
  },

  methods: {
    async loadMessages () {
      this.$store.commit('toggle_dialog', true)

      try {
        const url = `caregiversV3/${this.$store.state.Dbasename}/${this.$store.state.userId}/pupilsV3/${this.$store.state.pupilId}/teachermessagesV3`
        const response = await this.$http.get(url)
        if (response.data.length === 0) {
          this.isEmpty = true
        }

        this.messages = response.data
      } catch (error) {
        console.error('Error loading messages:', error)
      } finally {
        this.$store.commit('loading', false)
      }
    },

    orderMessages () {
    }
  }
}
</script>
